import * as React from 'react';
import { StyleSheet } from 'react-native';
import Animated, { useAnimatedScrollHandler } from 'react-native-reanimated';
import { Button, Indicator, SCROLL_INDICATOR_INSETS, Spacer, rem } from 'design-system';
import { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import { useAppSelector } from 'store/hooks';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import AARNote from 'features/invest/components/AARNote';
import { selectMostHeldStocks, selectShowInvestIntro } from '../reducers/selectors';
import useFundPickerStore from '../hooks/useFundPickerStore';
import { useFetchMostHeldStocks } from '../hooks/useMostHeldStocks';
import MostHeldStocksSection from './MostHeldStocksSection';
import ThemedAssetCategorizationView from './ThemedAssetCategorizationView';
import GeographicAssetCategorizationView from './GeographicAssetCategorizationView';
import { isWeb } from '../../../constants';
const DoItYourselfFunds = ({ scrollY }) => {
    const navigation = useMainStackNavigation();
    const { active: fundPickerMode } = useFundPickerStore();
    const showSetupButton = useAppSelector(selectShowInvestIntro);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const extraPadding = showSetupButton ? rem(64) : 0;
    const paddingBottom = useMarginBottom('paddingBottom', !fundPickerMode ? HEIGHT_PLUS_PADDING + extraPadding : 0, paddingHorizontalStyle);
    const assets = useAppSelector((state) => state.unpersistedInvestReducer.secclAssets);
    // Keep the loader up until "Most popular" can render too, otherwise it appears
    // later at the top and pushes the rest of the page down.
    // A list cached from a previous visit renders straight away and refreshes in the background.
    const mostHeldStocks = useAppSelector(selectMostHeldStocks);
    const hasFetchedMostHeldStocks = useFetchMostHeldStocks();
    const isWaitingForMostHeldStocks = !mostHeldStocks?.length && !hasFetchedMostHeldStocks;
    const scrollHandler = useAnimatedScrollHandler((handle) => {
        // eslint-disable-next-line no-param-reassign
        scrollY.value = handle.contentOffset.y;
    }, []);
    if (!assets?.length || isWaitingForMostHeldStocks) {
        return <Indicator dark style={styles.indicator}/>;
    }
    return (<Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} keyboardShouldPersistTaps="handled" contentContainerStyle={paddingBottom} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
      <MostHeldStocksSection shouldFetch={false}/>
      <Spacer.H8 />
      <AARNote />
      <Spacer.H8 />
      <GeographicAssetCategorizationView />
      <ThemedAssetCategorizationView />
      {fundPickerMode ? (<>
          <Spacer h={16}/>
          <Button title="See all funds" brandReversed style={styles.marginHorizontal} onPress={() => navigation.navigateDeprecated('InvestSearchStock')}/>
        </>) : null}
    </Animated.ScrollView>);
};
export default React.memo(DoItYourselfFunds);
const styles = StyleSheet.create({
    indicator: {
        marginBottom: '20%',
    },
    marginHorizontal: {
        marginHorizontal: rem(16),
    },
});
